import { useState } from 'react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Checkbox } from '../../components/ui/checkbox';
import { Slider } from '../../components/ui/slider';
import { Copy, RefreshCw } from 'lucide-react';
import { toast } from 'sonner';

const PasswordGeneratorTool = () => {
  const [password, setPassword] = useState('');
  const [length, setLength] = useState([16]);
  const [options, setOptions] = useState({
    uppercase: true,
    lowercase: true,
    numbers: true,
    symbols: true,
  });

  const generatePassword = () => {
    let chars = '';
    if (options.uppercase) chars += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    if (options.lowercase) chars += 'abcdefghijklmnopqrstuvwxyz';
    if (options.numbers) chars += '0123456789';
    if (options.symbols) chars += '!@#$%^&*()_+-=[]{}|;:,.<>?';
    
    if (!chars) {
      toast.error('Select at least one character type');
      return;
    }
    
    let result = '';
    for (let i = 0; i < length[0]; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setPassword(result);
  };

  const copyToClipboard = () => {
    if (password) {
      navigator.clipboard.writeText(password);
      toast.success('Password copied!');
    }
  };

  return (
    <div className="space-y-6" data-testid="password-generator-tool">
      <div className="flex justify-between items-center">
        <h3 className="font-semibold">Password Generator</h3>
      </div>

      <div className="space-y-4">
        <div>
          <label className="text-sm text-muted-foreground mb-2 block">Length: {length[0]}</label>
          <Slider
            value={length}
            onValueChange={setLength}
            min={8}
            max={64}
            step={1}
            className="w-full"
            data-testid="length-slider"
          />
        </div>

        <div className="grid grid-cols-2 gap-4">
          {Object.entries(options).map(([key, value]) => (
            <div key={key} className="flex items-center gap-2">
              <Checkbox
                id={key}
                checked={value}
                onCheckedChange={(checked) => setOptions({ ...options, [key]: checked })}
              />
              <label htmlFor={key} className="text-sm capitalize">{key}</label>
            </div>
          ))}
        </div>

        <Button onClick={generatePassword} className="w-full" data-testid="generate-btn">
          <RefreshCw className="w-4 h-4 mr-2" />
          Generate Password
        </Button>

        {password && (
          <div className="flex gap-2">
            <Input
              value={password}
              readOnly
              className="font-mono bg-background/50"
              data-testid="password-output"
            />
            <Button variant="outline" onClick={copyToClipboard} data-testid="copy-btn">
              <Copy className="w-4 h-4" />
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default PasswordGeneratorTool;
